import { Injectable } from '@angular/core';
import { AccountRegistrationService } from '../services/account-registration.service';

@Injectable()
export class PendingAccountRegistrationResolver {
  constructor(private accountRegistration: AccountRegistrationService) {}

  resolve() {
    return this.accountRegistration.getPendingRegistrations();
  }
}
